import React from 'react';
import Dialog from 'nucleus-core/dialog/Dialog';
import AnimationUpStyles from 'nucleus-core/less/cv/Dialog.transitionUp.less';
import DialogStyles from 'nucleus-core/less/cv/Dialog.less';
import PropTypes from 'prop-types';
import ThemeableComponent from 'nucleus-widgets/lib/ThemeableComponent';

export default class CCPAOptOutDialog extends ThemeableComponent {
  static displayName = 'CCPAOptOutDialog';
  static propTypes = {
    isOpen: PropTypes.bool,
    isModal: PropTypes.bool,
    header: PropTypes.string,
    isFixedHeader: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    children: PropTypes.node,
    translate: PropTypes.func,
    handleDialogClose: PropTypes.func,
    style: PropTypes.object,
    classes: PropTypes.object
  };

  render() {
    const { isOpen, isModal, header, isFixedHeader, classes, style } = this.props;

    const CCPADialogStyle = {
      ...DialogStyles,
      content: classes.content,
      transition: AnimationUpStyles
    };

    const headerStyle = {
      ...style.headerFont,
      ...style.header
    };

    const popUpDialogConfig = {
      requestClose: this.props.handleDialogClose,
      dialogId: 'CCPAOptOutDialog',
      isOpen,
      isModal,
      header,
      isFixedHeader,
      closeDialogOnOverlayClick: true,
      style: { ...style, header: headerStyle },
      classes: CCPADialogStyle
    };


    return (
      <div id="OptOutDialog">
        <Dialog
          {...popUpDialogConfig}
        >
          {this.props.children}
        </Dialog>
      </div>
    );
  }
}

